'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginStore = _reflux2.default.createStore({

    listenables: [_Actions2.default],

    informLoginChange: function informLoginChange(currentUser) {
        this.triggerLoginChange(currentUser);
    },
    triggerLoginChange: function triggerLoginChange(currentUser) {
        this.trigger('change', currentUser);
    }
});
exports.default = LoginStore;


//////////////////
// WEBPACK FOOTER
// ./src/stores/LoginStore.jsx
// module id = 320
// module chunks = 0